import { Stack, useMediaQuery } from "@mui/material";
import ImageAssets from "../../../../assets";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import styles from "./Screen1.module.css";
import { BottomSheetWithDialog } from "../../../../components/common/bottom-sheet-with-dialog/BottomSheetWithDialog";
import { useState } from "react";

const Screen1 = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 839px)");
  const [openModal, setOpenModal] = useState(false);

  return (
    <div className={styles.container}>
      {isMobile && (
        <div className={styles.tabsContainerMobile}>
          <Stack
            columnGap={1}
            alignItems={"center"}
            onClick={() => navigate(-1)}
          >
            <ArrowBackIosNewIcon
              sx={{
                fontSize: "26px",
                color: "var(--secondary-lite-grey-color)",
              }}
            />
          </Stack>
        </div>
      )}
      <img
        src={ImageAssets.ig_group7}
        alt="Group7"
        style={{
          width: "100%",
          height: "20rem",
          objectFit: "contain",
        }}
      />
      <h1 className={styles.textBig}>
        Collaboration Policy <br /> & Agreement in Projects
      </h1>
      <p className={styles.textSmall}>
        Every Project on Sekeron is backed by collaboration agreement and policy
        which protects the artists collaborating on Sekeron.
      </p>

      <div className={styles.gradientLine}></div>

      <h2 className={styles.textBig}>Why is it there?</h2>

      <Segment text="Makes roles clear in projects" image={ImageAssets.ig_01} />
      <Segment
        text="Protects copyright of artists while collaborating"
        image={ImageAssets.ig_02}
        alt
      />
      <Segment
        text="Reduces misunderstandings while collaborating"
        image={ImageAssets.ig_03}
      />
      <Segment
        text="Builds trust to work with new people"
        image={ImageAssets.ig_04}
        alt
      />

      <Note text="Sekeron is not part of the contract, we provide basic terms which artists can also overturn by adding terms of their own and will only be added when artists accept the terms." />

      <div className={styles.gradientLine}></div>

      <h2 className={styles.textBig}>How does it work?</h2>

      <div className={styles.segment}>
        <img src={ImageAssets.ig_06} alt="Segment 1" className={styles.image} />
        <p className={styles.segmentTxtSm}>
          Whenever an artist creates a new project, it is automatically created
          with the project details.
        </p>
      </div>
      <div className={styles.segment}>
        <img src={ImageAssets.ig_05} alt="Segment 2" className={styles.image} />
        <p className={styles.segmentTxtSm}>
          It is also automatically updated whenever an artist joins the
          collaboration with the terms agreed between the artists.
        </p>
      </div>

      <div className={styles.gradientLine}></div>

      <div className={styles.collabTitle}>
        <h2 className={styles.textBig} style={{ flex: 1 }}>
          4 types of collaborations
        </h2>
        <p
          className={styles.infoButton}
          onClick={() => {
            setOpenModal(true);
          }}
        >
          i
        </p>
      </div>

      <Cards />

      <Note text="Sekeron does not facilitate money transaction through the platform. Users must take care of that outside Sekeron." />

      <div className={styles.gradientLine}></div>

      <h2 className={styles.textBig}>Where is the contract in project?</h2>
      <p className={styles.textSmall}>
        If you are accepted in a project or have created a project, you get
        access to Collab Space which has the Project Contract button
      </p>
      <img
        src={ImageAssets.collabspace}
        alt="Collab Space"
        style={{
          width: "100%",
          height: "19rem",
          objectFit: "contain",
          margin: "20px 0",
        }}
      />
      <p className={styles.textSmall} style={{ textAlign: "left" }}>
        If you want to read the collaboration policy and collaboration in
        detail, please go to the following resources:
      </p>
      <div className={styles.resources}>
        <p className={styles.textSmall}>Link 1</p>
        <p className={styles.textSmall}>Link 2</p>
      </div>
      <BottomSheetWithDialog
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
        width={"40rem"}
      >
        <div
          style={
            isMobile
              ? {
                  borderTopLeftRadius: "15px",
                  borderTopRightRadius: "15px",
                  background: "var(--secondary-theme-color)",
                  top: "50%",
                  position: "absolute",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "0 5px",
                }
              : {
                  background: "var(--secondary-theme-color)",
                  width: "60rem",
                  position: "absolute",
                  top: "25%",
                  left: "25%",
                  borderRadius: "1.5rem",
                  height: "35rem",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 5px",
                }
          }
        >
          {isMobile && (
            <div
              style={{
                width: "4rem",
                height: "5px",
                borderRadius: 100,
                backgroundColor: "white",
                marginTop: "1rem",
              }}
            ></div>
          )}
          <div style={isMobile ? { marginTop: "1rem" } : null}>
            <p className={styles.textBig}>
              Before you proceed further, know these terms:
            </p>
          </div>
          <div
            style={{
              width: "80%",
              marginTop: "3rem",
            }}
          >
            <ul
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "2rem",
              }}
            >
              <li>
                <p
                  style={{
                    fontSize: "1.4rem",
                    color: "white",
                    fontFamily: "Comfortaa-Bold",
                  }}
                >
                  1. Project Initiator
                </p>
                <p
                  style={{
                    color: "grey",
                    fontSize: "1.4rem",
                    fontFamily: "Comfortaa-Light",
                    marginTop: "1rem",
                    lineHeight: "1.8rem",
                  }}
                >
                  The artist on Sekeron who starts a projects
                </p>
              </li>
              <li>
                <p
                  style={{
                    fontSize: "1.4rem",
                    color: "white",
                    fontFamily: "Comfortaa-Bold",
                  }}
                >
                  2. Copyright ownership
                </p>
                <p
                  style={{
                    color: "grey",
                    fontSize: "1.4rem",
                    fontFamily: "Comfortaa-Light",
                    marginTop: "1rem",
                    lineHeight: "1.8rem",
                  }}
                >
                  Collaborator or collaborators who have the economic copyrights
                  only.
                </p>
              </li>
              <li>
                <p
                  style={{
                    fontSize: "1.4rem",
                    color: "white",
                    fontFamily: "Comfortaa-Bold",
                  }}
                >
                  3. Revenue Split
                </p>
                <p
                  style={{
                    color: "grey",
                    fontSize: "1.4rem",
                    fontFamily: "Comfortaa-Light",
                    marginTop: "1rem",
                    lineHeight: "1.8rem",
                  }}
                >
                  How money earned from the project is divided among the
                  collaborators.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </BottomSheetWithDialog>
    </div>
  );
};

const Segment = ({ text, image, alt = false }) => (
  <div className={`${styles.segment} ${alt ? styles.reverse : ""}`}>
    <img src={image} alt={text} className={styles.image} />
    <p className={styles.segmentTxt}>{text}</p>
  </div>
);

const Note = ({ text }) => {
  return (
    <div className={styles.noteContainer}>
      <p className={styles.noteText}>
        Please Note: <span className={styles.noteTextGrey}>{text}</span>
      </p>
    </div>
  );
};

const Card = ({ ownership, split, desc, image, alt }) => {
  const isMobile = useMediaQuery("(max-width: 839px)");
  return (
    <div className={styles.cardContainer}>
      <div
        className={styles.cardSubcontainer}
        style={alt ? { flexDirection: "row-reverse" } : null}
      >
        <div style={{ gap: 10 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
            }}
          >
            <p
              className={styles.textSmall}
              style={{ fontSize: isMobile ? "1rem" : "1.2rem" }}
            >
              Copyright ownership
            </p>
            <p
              className={styles.textBig}
              style={{ fontSize: isMobile ? "1rem" : "1.4rem" }}
            >
              {ownership}
            </p>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
            }}
          >
            <p
              className={styles.textSmall}
              style={{ fontSize: isMobile ? "1rem" : "1.2rem" }}
            >
              Revenue Split
            </p>
            <p
              className={styles.textBig}
              style={{ fontSize: isMobile ? "1rem" : "1.4rem" }}
            >
              {split}
            </p>
          </div>
        </div>
        <img
          src={image}
          alt="Equal"
          className={styles.cardImage}
          style={{ left: 20 }}
        />
      </div>
      <div className={styles.cardDescription}>
        <p
          className={styles.textSmall}
          style={{ textAlign: "left", fontSize: "1.4rem" }}
        >
          {desc}
        </p>
      </div>
    </div>
  );
};

const Cards = () => {
  const cardData = [
    {
      ownership: "Solo owner",
      split: "Equal",
      desc: "The project initiator owns the copyright but shares any money earned equally with all collaborators.",
      image: ImageAssets.equal,
    },
    {
      ownership: "Co-owner",
      split: "Equal",
      desc: "All collaborators own the copyrights and share any money earned equally.",
      image: ImageAssets.coowner,
      alt: true,
    },
    {
      ownership: "Solo owner",
      split: "Unequal",
      desc: "The project initiator owns the copyright and project initiator negotiates % of revenue shared between collaborators.",
      image: ImageAssets.unequal,
    },
    {
      ownership: "Co-owner",
      split: "Equal",
      desc: "All collaborators own the copyrights and share any money earned equally.",
      image: ImageAssets.counequal,
      alt: true,
    },
  ];

  return (
    <>
      {cardData.map((data, index) => (
        <Card
          key={index}
          ownership={data.ownership}
          split={data.split}
          desc={data.desc}
          image={data.image}
          alt={data.alt ? true : false}
        />
      ))}
    </>
  );
};

export default Screen1;
